import { Box, Typography } from "@mui/material";
import React from "react";
import MapLinearBar from "../MapLinearBar";
import "./index.scss";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function StatePopup({ location }) {
  return (
    <Box>
      <div className="country-box">
        {location?.map((data, index) => (
          <div className="bar bar_one" key={index}>
            <div className="c-name">
              <span>{data.country}</span>
            </div>
            <div className="level">
              <MapLinearBar value={`${data.value2}%`} />
              <div className="info new">
                <span>{data.value2}%</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
}
